// Area: account (owner account-settings, plan §9.3). The light part of the account contracts: `/me`,
// own preferences, the dev login and sign-out. The session guard of every authenticated screen calls
// them, so this module imports nothing but the core session schemas and `defineContract`; the rest
// of the account contracts (`@dataroom/contracts/account`, which re-exports this module) stays out
// of the first paint (plan §12).
import { z } from 'zod';
import { DevLoginInput, DevUserDTO, MeDTO, UpdateMemberPreferencesBody } from '@dataroom/core';
import { defineContract } from '../../define';

export { MeDTO };

export const getMe = defineContract({
  method: 'GET',
  path: '/me',
  response: MeDTO,
  summary: 'The signed-in member, workspace, permissions, effective formats and the server clock',
});

export const updateMyPreferences = defineContract({
  method: 'PATCH',
  path: '/me/preferences',
  body: UpdateMemberPreferencesBody,
  response: MeDTO,
  summary:
    'Set your own language, time zone, number and date format, theme and start page (null follows the workspace)',
});

export const listDevUsers = defineContract({
  method: 'GET',
  path: '/auth/dev-users',
  public: true,
  response: z.array(DevUserDTO),
  summary: 'Seeded users available for the dev login (DR_DEV_LOGIN=1)',
});

export const devLogin = defineContract({
  method: 'POST',
  path: '/auth/dev-login',
  public: true,
  body: DevLoginInput,
  response: MeDTO,
  summary: 'Sign in as a seeded member without a password (development only)',
});

export const logout = defineContract({
  method: 'POST',
  path: '/auth/logout',
  public: true,
  response: z.void(),
  summary: 'End the current session',
});
